import styled from 'styled-components';
import { shade } from 'polished';

import { colors, radius } from '../../styles/tokens';

export const Container = styled.input`
  width: 100%;
  height: 55px;

  background-color: ${colors.primary};

  color: ${colors.onPrimary};
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  border-radius: ${radius.full};
  border: none;

  transition: background-color 0.2s;

  &:hover {
    background-color: ${shade(0.2, colors.primary)};
  }

  &:disabled {
    background-color: ${shade(0.5, colors.primary)};
  }
`;
